import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { DroneManufacturer } from '../data-models/drone-manufacturer.model';
import { DroneManufacturerRequest } from '../request-models/drone-manufacturer-request.model';
import { toDroneManufacturerRequest } from '../utils/drone-catalog-request-utils';

/** The drone catalog's manufacturers: `/admin/drone-manufacturers` (hub `admin-drone-manufacturers-controller.ts`). */
@Injectable({ providedIn: 'root' })
export class DroneManufacturerService extends BaseService<DroneManufacturer> {
  constructor() {
    super('admin/drone-manufacturers', DroneManufacturer);
  }

  /** GET /admin/drone-manufacturers (unpaged). */
  getManufacturers(): Observable<DroneManufacturer[]> {
    return this.getMany();
  }

  /** GET /admin/drone-manufacturers/:id. Emits `null` when the hub returns no data. */
  getManufacturer(manufacturerId: string): Observable<DroneManufacturer | null> {
    return this.get(manufacturerId);
  }

  /** POST /admin/drone-manufacturers with only the writable fields that are set. */
  createManufacturer(fields: DroneManufacturerRequest): Observable<DroneManufacturer | null> {
    return this.create(toDroneManufacturerRequest(fields));
  }

  /** PUT /admin/drone-manufacturers/:id with only the writable fields that are set. */
  updateManufacturer(manufacturerId: string, fields: DroneManufacturerRequest): Observable<DroneManufacturer | null> {
    return this.update(manufacturerId, toDroneManufacturerRequest(fields));
  }

  /** DELETE /admin/drone-manufacturers/:id (the hub archives it). */
  archiveManufacturer(manufacturerId: string): Observable<void> {
    return this.delete(manufacturerId);
  }
}
